import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DATE_FORMAT } from './date-format';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatSelectModule,
        MatOptionModule,
        MatRadioModule,
        FormsModule,
        MatExpansionModule,
        MatStepperModule,
        MatTableModule,
        MatDialogModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatAccordion,
        MatExpansionPanel,
        MatListModule,
        MatDatepickerModule,
        MatPaginatorModule,
        MatPaginator,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        ClipboardModule,
        MatSortModule,
        MatNativeDateModule,
    ],
    exports: [
        CommonModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MatIconModule,
        MatInputModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatSelectModule,
        MatOptionModule,
        MatRadioModule,
        FormsModule,
        MatExpansionModule,
        MatStepperModule,
        MatTableModule,
        MatDialogModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatAccordion,
        MatExpansionPanel,
        MatListModule,
        MatDatepickerModule,
        MatPaginatorModule,
        MatPaginator,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        ClipboardModule,
        MatSortModule,
        MatNativeDateModule,
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT },
    ],
})
export class MaterialModule {}
